import React from 'react'
import { SectionCard } from '../../components/sections/SectionCard'
import { ExternalLink } from 'lucide-react'
import type { PricingTable } from '@/features/subscriptions/types/pricing-table/pricing-table.types'

interface EmbedsSectionProps {
  isDetailView?: boolean
  pricingTableData?: PricingTable
  className?: string
}

export const EmbedsSection = React.memo<EmbedsSectionProps>(({
  isDetailView = false,
  pricingTableData,
  className,
}) => {
  const embeds = pricingTableData?.embeds || []

  if (embeds.length === 0) {
    return (
      <SectionCard title="Embeds" className={className}>
        <div className="py-8 text-center text-sm text-muted-foreground">
          No embeds configured. Publish this pricing table to add embeds.
        </div>
      </SectionCard>
    )
  }

  return (
    <SectionCard
      title={`Embeds (${embeds.length})`}
      isCollapsible={!isDetailView}
      className={className}
    >
      <div className="divide-y">
        {embeds.map((embed, i) => (
          <div key={i} className="flex items-center justify-between px-4 py-3">
            <div className="flex flex-col gap-0.5">
              <span className="text-sm font-medium">{embed.location}</span>
              <span className="text-xs text-muted-foreground">{embed.url}</span>
            </div>
            <a
              href={embed.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <ExternalLink className="size-4" />
            </a>
          </div>
        ))}
      </div>
    </SectionCard>
  )
})

EmbedsSection.displayName = 'EmbedsSection'
